<template>
  <select class="form-select form-control" v-model="selectedProductId">
    <option v-for="product in products"
            :key="'ps_' + product.id"
            :value="product.id"
            :selected="value === product.id">
      {{ product.name }}{{product.category === 'RES' ? ' | ' + product.duration + 'h' : ''}}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    value: String,
    categories: Array
  },
  data() {
    return {
      products: [],
      selectedProductId: this.value
    }
  },
  watch: {
    selectedProductId() {
      this.$emit('input', this.selectedProductId)
    }
  },
  methods: {
    loadProducts() {
      this.$api.get('/products', {
        params: {
          category: 'RES'
        }
      }).then(result => this.products = result.data)
          .catch(error => this.handleError(error))
    }
  },
  mounted() {
    this.loadProducts()
  }
}
</script>
